import { createAsyncThunk } from "@reduxjs/toolkit"
import { del, get, patch, post, put } from "helpers/api_helper"
import {
  CLEAR_DASHBOARD_CACHE,
  EXPORT_BY_TYPE,
  GET_CITY_API,
  GET_DROPDOWN_API,
  GET_JOB_TITLES,
  GET_STATION_SHIFT_DROPDOWN_LIST,
  GET_SYSTEM_NATIONALITIES,
} from "helpers/url_helper"

export const getDropdownData = createAsyncThunk(
  GET_DROPDOWN_API,
  async payload => {
    const response = await post(GET_DROPDOWN_API, payload)
    return response
  }
)

export const getSystemNationalities = createAsyncThunk(
  GET_SYSTEM_NATIONALITIES,
  async () => {
    const response = await get(GET_SYSTEM_NATIONALITIES)
    return response
  }
)

export const getCityData = createAsyncThunk(GET_CITY_API, async payload => {
  const response = await get(GET_CITY_API)
  return response
})

export const getJobTitlesList = createAsyncThunk(
  GET_JOB_TITLES,
  async payload => {
    const response = await get(GET_JOB_TITLES, payload)
    return response
  }
)

export const exportByType = createAsyncThunk(EXPORT_BY_TYPE, async payload => {
  const response = await post(EXPORT_BY_TYPE, payload)
  return response
})

export const getStationShiftDropdownList = createAsyncThunk(
  GET_STATION_SHIFT_DROPDOWN_LIST,
  async () => {
    const response = await get(GET_STATION_SHIFT_DROPDOWN_LIST)
    return response
  }
)

export const clearDashboardCache = createAsyncThunk(
  CLEAR_DASHBOARD_CACHE,
  async () => {
    const response = await get(CLEAR_DASHBOARD_CACHE)
    return response
  }
)
